import { fetchPlayerFirestoreAPI } from '../../../firebase/firebaseAPICalls/FirebaseAPICallsPlayer';
import { isValidObject, isValidString } from '../../Validity';

// ---------------------------------------------------------------------------------------------------------
// Try
// ---------------------------------------------------------------------------------------------------------

export const databaseTryToLocalTry = async (rugbyTry: any) => {
    const updatedTry = { ...rugbyTry };
    if (rugbyTry.team === 'our' && isValidString(rugbyTry.playerId)) {
        const playerDoc = await fetchPlayerFirestoreAPI(rugbyTry.playerId);
        if (playerDoc.exists && !playerDoc.data()?.deleted) {
            updatedTry.playerName = playerDoc.data()?.name;
        } else {
            updatedTry.playerName = '';
        }
    } else {
        updatedTry.playerName = '';
    }

    if (rugbyTry.team === 'our' && isValidString(rugbyTry.assistId)) {
        const assistDoc = await fetchPlayerFirestoreAPI(rugbyTry.assistId);
        if (assistDoc.exists && !assistDoc.data()?.deleted) {
            updatedTry.assistName = assistDoc.data()?.name;
        } else {
            updatedTry.assistName = '';
        }
    } else {
        updatedTry.assistName = '';
    }
    return updatedTry;
};

export const databaseTriesToLocalTries = async (tries: any[]) => {
    if (isValidObject(tries)) {
        const updatedTries = Array<any>(tries.length);
        await (Promise.all(tries.map(async (rugbyTry, index) => {
            updatedTries[index] = await databaseTryToLocalTry(rugbyTry);
        })));
        return updatedTries;
    }
    return [];
};

// ---------------------------------------------------------------------------------------------------------
// Conversion
// ---------------------------------------------------------------------------------------------------------

export const databaseConversionToLocalConversion = async (conversion: any) => {
    const updatedConversion = { ...conversion };
    if (isValidString(conversion.playerId)) {
        const playerDoc = await fetchPlayerFirestoreAPI(conversion.playerId);
        if (playerDoc.exists && !playerDoc.data()?.deleted) {
            updatedConversion.playerName = playerDoc.data()?.name;
        } else {
            updatedConversion.playerName = '';
        }
    } else {
        updatedConversion.playerName = '';
    }

    return updatedConversion;
};

export const databaseConversionsToLocalConversions = async (conversions: any[]) => {
    if (isValidObject(conversions)) {
        const updatedConversions = Array<any>(conversions.length);
        await (Promise.all(conversions.map(async (conversion, index) => {
            updatedConversions[index] = await databaseConversionToLocalConversion(conversion);
        })));
        return updatedConversions;
    }
    return [];
};

// ---------------------------------------------------------------------------------------------------------
// Penalty Kick
// ---------------------------------------------------------------------------------------------------------

export const databasePenaltyKickToLocalPenaltyKick = async (penaltyKick: any) => {
    const updatedPenaltyKick = { ...penaltyKick };
    if (penaltyKick.team === 'our' && isValidString(penaltyKick.playerId)) {
        const playerDoc = await fetchPlayerFirestoreAPI(penaltyKick.playerId);
        if (playerDoc.exists && !playerDoc.data()?.deleted) {
            updatedPenaltyKick.playerName = playerDoc.data()?.name;
        } else {
            updatedPenaltyKick.playerName = '';
        }
    } else {
        updatedPenaltyKick.playerName = '';
    }

    return updatedPenaltyKick;
};

export const databasePenaltyKicksToLocalPenaltyKicks = async (penaltyKicks: any[]) => {
    if (isValidObject(penaltyKicks)) {
        const updatedPenaltyKicks = Array<any>(penaltyKicks.length);
        await (Promise.all(penaltyKicks.map(async (penalty, index) => {
            updatedPenaltyKicks[index] = await databasePenaltyKickToLocalPenaltyKick(penalty);
        })));
        return updatedPenaltyKicks;
    }
    return [];
};

// ---------------------------------------------------------------------------------------------------------
// Drop Goal
// ---------------------------------------------------------------------------------------------------------

export const databaseDropGoalToLocalDropGoal = async (dropGoal: any) => {
    const updatedDropGoal = { ...dropGoal };
    if (dropGoal.team === 'our' && isValidString(dropGoal.playerId)) {
        const playerDoc = await fetchPlayerFirestoreAPI(dropGoal.playerId);
        if (playerDoc.exists && !playerDoc.data()?.deleted) {
            updatedDropGoal.playerName = playerDoc.data()?.name;
        } else {
            updatedDropGoal.playerName = '';
        }
    } else {
        updatedDropGoal.playerName = '';
    }

    return updatedDropGoal;
};

export const databaseDropGoalsToLocalDropGoals = async (dropGoals: any[]) => {
    if (isValidObject(dropGoals)) {
        const updatedDropGoals = Array<any>(dropGoals.length);
        await (Promise.all(dropGoals.map(async (dropGoal, index) => {
            updatedDropGoals[index] = await databaseDropGoalToLocalDropGoal(dropGoal);
        })));
        return updatedDropGoals;
    }
    return [];
};

// ---------------------------------------------------------------------------------------------------------
// Foul
// ---------------------------------------------------------------------------------------------------------

export const databaseFoulToLocalFoul = async (foul: any) => {
    const updatedFoul = { ...foul };
    if (foul.team === 'our' && isValidString(foul.playerId)) {
        const playerDoc = await fetchPlayerFirestoreAPI(foul.playerId);
        if (playerDoc.exists && !playerDoc.data()?.deleted) {
            updatedFoul.playerName = playerDoc.data()?.name;
        } else {
            updatedFoul.playerName = '';
        }
    } else {
        updatedFoul.playerName = '';
    }

    return updatedFoul;
};

export const databaseFoulsToLocalFouls = async (fouls: any[]) => {
    if (isValidObject(fouls)) {
        const updatedFouls = Array<any>(fouls.length);
        await (Promise.all(fouls.map(async (foul, index) => {
            updatedFouls[index] = await databaseFoulToLocalFoul(foul);
        })));
        return updatedFouls;
    }
    return [];
};

// ---------------------------------------------------------------------------------------------------------
// Tackle
// ---------------------------------------------------------------------------------------------------------

export const databaseTackleToLocalTackle = async (tackle: any) => {
    const updatedTackle = { ...tackle };
    if (tackle.team === 'our' && isValidString(tackle.playerId)) {
        const playerDoc = await fetchPlayerFirestoreAPI(tackle.playerId);
        if (playerDoc.exists && !playerDoc.data()?.deleted) {
            updatedTackle.playerName = playerDoc.data()?.name;
        } else {
            updatedTackle.playerName = '';
        }
    } else {
        updatedTackle.playerName = '';
    }

    return updatedTackle;
};

export const databaseTacklesToLocalTackles = async (tackles: any[]) => {
    if (isValidObject(tackles)) {
        const updatedTackles = Array<any>(tackles.length);
        await (Promise.all(tackles.map(async (tackle, index) => {
            updatedTackles[index] = await databaseTackleToLocalTackle(tackle);
        })));
        return updatedTackles;
    }
    return [];
};

// ---------------------------------------------------------------------------------------------------------
// Offload
// ---------------------------------------------------------------------------------------------------------

export const databaseOffloadToLocalOffload = async (offload: any) => {
    const updatedOffload = { ...offload };
    if (offload.team === 'our' && isValidString(offload.playerId)) {
        const playerDoc = await fetchPlayerFirestoreAPI(offload.playerId);
        if (playerDoc.exists && !playerDoc.data()?.deleted) {
            updatedOffload.playerName = playerDoc.data()?.name;
        } else {
            updatedOffload.playerName = '';
        }
    } else {
        updatedOffload.playerName = '';
    }

    return updatedOffload;
};

export const databaseOffloadsToLocalOffloads = async (offloads: any[]) => {
    if (isValidObject(offloads)) {
        const updatedOffloads = Array<any>(offloads.length);
        await (Promise.all(offloads.map(async (offload, index) => {
            updatedOffloads[index] = await databaseOffloadToLocalOffload(offload);
        })));
        return updatedOffloads;
    }
    return [];
};

// ---------------------------------------------------------------------------------------------------------
// Pass
// ---------------------------------------------------------------------------------------------------------

export const databasePassToLocalPass = async (pass: any) => {
    const updatedPass = { ...pass };
    if (pass.team === 'our' && isValidString(pass.playerId)) {
        const playerDoc = await fetchPlayerFirestoreAPI(pass.playerId);
        if (playerDoc.exists && !playerDoc.data()?.deleted) {
            updatedPass.playerName = playerDoc.data()?.name;
        } else {
            updatedPass.playerName = '';
        }
    } else {
        updatedPass.playerName = '';
    }

    return updatedPass;
};

export const databasePassesToLocalPasses = async (passes: any[]) => {
    if (isValidObject(passes)) {
        const updatedPasses = Array<any>(passes.length);
        await (Promise.all(passes.map(async (pass, index) => {
            updatedPasses[index] = await databasePassToLocalPass(pass);
        })));
        return updatedPasses;
    }
    return [];
};

// ---------------------------------------------------------------------------------------------------------
// Carry
// ---------------------------------------------------------------------------------------------------------

export const databaseCarryToLocalCarry = async (carry: any) => {
    const updatedCarry = { ...carry };
    if (carry.team === 'our' && isValidString(carry.playerId)) {
        const playerDoc = await fetchPlayerFirestoreAPI(carry.playerId);
        if (playerDoc.exists && !playerDoc.data()?.deleted) {
            updatedCarry.playerName = playerDoc.data()?.name;
        } else {
            updatedCarry.playerName = '';
        }
    } else {
        updatedCarry.playerName = '';
    }

    return updatedCarry;
};

export const databaseCarriesToLocalCarries = async (carries: any[]) => {
    if (isValidObject(carries)) {
        const updatedCarries = Array<any>(carries.length);
        await (Promise.all(carries.map(async (carry, index) => {
            updatedCarries[index] = await databaseCarryToLocalCarry(carry);
        })));
        return updatedCarries;
    }
    return [];
};

// ---------------------------------------------------------------------------------------------------------
// Meters Carried
// ---------------------------------------------------------------------------------------------------------

export const databaseMetersCarriedSingularToLocalMetersCarriedSingular = async (metersCarried: any) => {
    const updatedMetersCarried = { ...metersCarried };
    if (metersCarried.team === 'our' && isValidString(metersCarried.playerId)) {
        const playerDoc = await fetchPlayerFirestoreAPI(metersCarried.playerId);
        if (playerDoc.exists && !playerDoc.data()?.deleted) {
            updatedMetersCarried.playerName = playerDoc.data()?.name;
        } else {
            updatedMetersCarried.playerName = '';
        }
    } else {
        updatedMetersCarried.playerName = '';
    }

    return updatedMetersCarried;
};

export const databaseMetersCarriedToLocalMetersCarried = async (metersCarried: any[]) => {
    if (isValidObject(metersCarried)) {
        const updatedMetersCarried = Array<any>(metersCarried.length);
        await (Promise.all(metersCarried.map(async (metersCarriedSingular, index) => {
            updatedMetersCarried[index] = await databaseMetersCarriedSingularToLocalMetersCarriedSingular(metersCarriedSingular);
        })));
        return updatedMetersCarried;
    }
    return [];
};

// ---------------------------------------------------------------------------------------------------------
// Mins Played
// ---------------------------------------------------------------------------------------------------------

export const databaseMinsPlayedSingularToLocalMinsPlayedSingular = async (minsPlayed: any) => {
    const updatedMinsPlayed = { ...minsPlayed };
    if (minsPlayed.team === 'our' && isValidString(minsPlayed.playerId)) {
        const playerDoc = await fetchPlayerFirestoreAPI(minsPlayed.playerId);
        if (playerDoc.exists && !playerDoc.data()?.deleted) {
            updatedMinsPlayed.playerName = playerDoc.data()?.name;
        } else {
            updatedMinsPlayed.playerName = '';
        }
    } else {
        updatedMinsPlayed.playerName = '';
    }

    return updatedMinsPlayed;
};

export const databaseMinsPlayedToLocalMinsPlayed = async (minsPlayed: any[]) => {
    if (isValidObject(minsPlayed)) {
        const updatedMinsPlayed = Array<any>(minsPlayed.length);
        await (Promise.all(minsPlayed.map(async (minsPlayedSingular, index) => {
            updatedMinsPlayed[index] = await databaseMinsPlayedSingularToLocalMinsPlayedSingular(minsPlayedSingular);
        })));
        return updatedMinsPlayed;
    }
    return [];
};
